import {
  Body,
  Card,
  Divider,
  Heading,
  IconBulletList,
  IconBulletListProps,
  SelectButton,
  SelectedButtonListItemType,
} from '@trevor/ui-components';
import React, { FC } from 'react';
import styled from 'styled-components';
import { CONNECT_DATABASE_SETUP_TYPE } from '@/constants/test-ids';
import { DATABASE_SETUP_TYPE } from './utils';

const databaseCredentialOptions: SelectedButtonListItemType[] = [
  {
    iconName: 'heroku',
    label: 'Heroku quick setup',
    value: DATABASE_SETUP_TYPE.heroku,
  },
  {
    label: 'I know my database credentials',
    value: DATABASE_SETUP_TYPE.custom,
  },
  {
    label: 'Someone needs to help me',
    value: DATABASE_SETUP_TYPE.helpRequired,
  },
];

const getDatabaseCredentialOptions = (
  showHerokuButton: boolean,
): SelectedButtonListItemType[] => {
  let newDatabaseCredentialOptions = databaseCredentialOptions;

  if (!showHerokuButton) {
    newDatabaseCredentialOptions = newDatabaseCredentialOptions.filter(
      (option) => option.value !== DATABASE_SETUP_TYPE.heroku,
    );
  }

  return newDatabaseCredentialOptions;
};

const iconBulletListOptions: IconBulletListProps[] = [
  {
    iconName: 'illustration-security',
    bullets: ['Secure connection', 'Read-only transaction'],
  },
  {
    iconName: 'illustration-quick',
    bullets: ['2 minute set-up', 'Chat support'],
  },
];

const IconBulletListContainer = styled.div`
  display: flex;
  justify-content: space-evenly;
  margin: var(--spacing-m);
  gap: var(--spacing-xxl);
`;

const SelectButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: var(--spacing-l);
`;

const StyledSelectButton = styled(SelectButton)`
  width: 272px;
`;

type DatabaseSetupTypeSelectorStepProps = {
  selectedValue: Maybe<string>;
  showHerokuButton: boolean;
  onSelect: F<string>;
  onClose: F0;
};
export const DatabaseSetupTypeSelectorStep: FC<
  DatabaseSetupTypeSelectorStepProps
> = ({ selectedValue, showHerokuButton, onSelect, onClose }) => {
  return (
    <Card
      width="100%"
      alignItems="center"
      padding={32}
      gap={32}
      onClose={onClose}
    >
      <Heading variant={3}>Connect a database</Heading>
      <IconBulletListContainer>
        {iconBulletListOptions.map((option, index) => (
          <IconBulletList key={index} {...option} />
        ))}
      </IconBulletListContainer>
      <Body variant={1}>
        Data security is our first priority, which is why we're trusted by many
        of the world's most successful organizations.
      </Body>
      <Divider />
      <Heading variant={4}>Step 1: Your database credentials</Heading>
      <SelectButtonContainer>
        {getDatabaseCredentialOptions(showHerokuButton).map((option) => (
          <StyledSelectButton
            key={option.value}
            iconName={option.iconName}
            value={option.value}
            isSelected={selectedValue === option.value}
            onClick={() => onSelect(option.value)}
            data-testid={`${CONNECT_DATABASE_SETUP_TYPE}:${option.value}`}
          >
            {option.label}
          </StyledSelectButton>
        ))}
      </SelectButtonContainer>
    </Card>
  );
};
